import { useMediaQuery } from '@mui/material';
import Select from '@rio-cloud/rio-uikit/Select';

interface IBudgetRecipientSelectProps {
  recipient?: string;
  onRecipientChange: (recipientId?: string) => void;
  options?: Array<{ id: string; label: string }>;
  disabled?: boolean;
}

const BudgetRecipientSelect = (props: IBudgetRecipientSelectProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const optionsWithSelected = (props.options || []).map((option) => ({
    ...option,
    selected: option.id === props.recipient,
  }));

  return (
    <div className={`flex mb-6 ${isMobile ? 'px-2' : 'px-6'} flex-row`}>
      <div className={`justify-between flex flex-col ${isMobile ? 'w-full' : 'w-[250px]'}`}>
        <label className="mb-2">
          Enviar orçamento para <span className="text-red-500">*</span>
        </label>
        <Select
          value={props.recipient ? [props.recipient] : []}
          onChange={(option) => {
            props.onRecipientChange(option?.id);
          }}
          options={optionsWithSelected}
          disabled={props.disabled}
        />
      </div>
    </div>
  );
};

export default BudgetRecipientSelect;
